// extracted by mini-css-extract-plugin
export default {"root":"Comparables__root--HyB2J","intro":"Comparables__intro--iQtKx","holder":"Comparables__holder--YMUOx"};